import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const ReturnArrow = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsx("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M5.28782 13.5935H14C16.2091 13.5935 18 11.8026 18 9.5935V7.5M7.83395 10.8201L5 13.6601L7.83395 16.5",
            stroke: "currentColor",
            strokeWidth: 1.5 * (24 / size),
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
